export default __webpack_public_path__ + "static/media/PPI-garden-bed-003.380def47.jpg";